import React from 'react';
import { StatusTag, rem } from '@innovyze/stylovyze';
import { useGlobalization } from '@Translations/useGlobalization';
import { Configuration } from '@Types';

interface ConfigurationStatusTagProps {
	status: Configuration['status'];
}

export const ConfigurationStatusTag = ({
	status,
}: ConfigurationStatusTagProps) => {
	const { t } = useGlobalization();
	if (status === 'Good')
		return <StatusTag text={t('Good')} color="positive" width={rem(50)} />;
	if (status === 'Fair')
		return <StatusTag text={t('Fair')} color="warning" width={rem(50)} />;
	if (status === 'Poor')
		return <StatusTag text={t('Poor')} color="danger" width={rem(50)} />;
	return <></>;
};
